import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import store from "./../store/index";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: () => import(/* webpackChunkName: "home" */ "../views/Home.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/links",
    name: "Links",
    component: () =>
      import(/* webpackChunkName: "links" */ "../views/Links.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/pages",
    name: "Pages",
    component: () =>
      import(/* webpackChunkName: "links" */ "../views/Pages.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/phones",
    name: "Phones",
    component: () =>
      import(/* webpackChunkName: "phones" */ "../views/Phones.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/profile/",
    name: "Configs",
    component: () =>
      import(/* webpackChunkName: "configs" */ "../views/Configs.vue"),
    children: [
      {
        path: "user",
        name: "Configs",
        component: () =>
          import(
            /* webpackChunkName: "user" */ "../views/Configs/userProfile.vue"
          )
      },
      {
        path: "pass",
        name: "Configs",
        component: () =>
          import(/* webpackChunkName: "pass" */ "../views/Configs/userPass.vue")
      },
      {
        path: "client",
        name: "Configs",
        component: () =>
          import(
            /* webpackChunkName: "client" */ "../views/Configs/clientProfile.vue"
          )
      },
      {
        path: "users",
        name: "Configs",
        component: () =>
          import(
            /* webpackChunkName: "users" */ "../views/Configs/clientUsers.vue"
          )
      },
      {
        path: "plans",
        name: "Configs",
        component: () =>
          import(
            /* webpackChunkName: "plans" */ "../views/Configs/userPlans.vue"
          )
      },
      {
        path: "cards",
        name: "Configs",
        component: () =>
          import(
            /* webpackChunkName: "cards" */ "../views/Configs/userCards.vue"
          )
      },
      {
        path: "invoices",
        name: "Configs",
        component: () =>
          import(
            /* webpackChunkName: "invoices" */ "../views/Configs/clientInvoices.vue"
          )
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Auth/Login.vue"),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/register",
    name: "Register",
    component: () =>
      import(/* webpackChunkName: "register" */ "../views/Auth/Register.vue"),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/reset",
    name: "Reset",
    component: () =>
      import(/* webpackChunkName: "reset" */ "../views/Auth/ResetPass.vue"),
    meta: {
      requiresAuth: false
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  // store.dispatch("appStore/setLoadingStatus", true);
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    await store.dispatch("appStore/checkIfUserIsLoggedIn");
    const isLoggedIn = store.getters["appStore/isUserLoggedIn"];
    if (!isLoggedIn) {
      router.push("/login");
    }
    // store.dispatch("appStore/setLoadingStatus", false);
    next();
  } else {
    // store.dispatch("appStore/setLoadingStatus", false);
    next();
  }
});

export default router;
